var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 12,
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0659 0C18.9978 0 18.1319 0.859694 18.1319 1.92014C18.1319 2.18617 18.1864 2.43958 18.285 2.66995L14.2335 6.69226C14.0015 6.59443 13.7462 6.54023 13.4782 6.54023C13.2102 6.54023 12.955 6.59443 12.7229 6.69226L10.3028 4.28954C10.4013 4.05917 10.4559 3.80576 10.4559 3.53968C10.4559 2.47923 9.58995 1.61954 8.52181 1.61954C7.45368 1.61954 6.58775 2.47923 6.58775 3.53968C6.58775 3.80571 6.64229 4.05912 6.74083 4.28949L2.68936 8.31175C2.45732 8.21392 2.20207 8.15972 1.93406 8.15972C0.865928 8.15972 0 9.01942 0 10.0799C0 11.1403 0.865928 12 1.93406 12C3.0022 12 3.86812 11.1403 3.86812 10.0799C3.86812 9.81383 3.81358 9.56042 3.71504 9.33005L7.76651 5.30779C7.99855 5.40562 8.2538 5.45977 8.52181 5.45977C8.78978 5.45977 9.04503 5.40562 9.27707 5.30779L11.6973 7.71056C11.5987 7.94092 11.5442 8.19433 11.5442 8.46037C11.5442 9.52081 12.4101 10.3805 13.4782 10.3805C14.5464 10.3805 15.4123 9.52081 15.4123 8.46037C15.4123 8.19433 15.3578 7.94092 15.2592 7.71056L19.3106 3.68825C19.5427 3.78608 19.7979 3.84023 20.0659 3.84023C21.1341 3.84023 22 2.98053 22 1.92009C22 0.859646 21.1341 0 20.0659 0Z",
    fill: "#565656",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightTrack);
export default __webpack_public_path__ + "static/media/light-track.c30c1c1c.svg";
export { ForwardRef as ReactComponent };